module.exports = __webpack_public_path__ + "static/media/image2.b621d3f7.jpg";